import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { consultantmage } from "../Constant/Index";
import { getPatientviewperscriptionapi } from "../network/Network";
import { useDispatch, useSelector } from "react-redux";
import { P_DETAIL } from "../redux/Slices/AuthSlice";

const UserPrescription = () => {
	const dispatch = useDispatch();
	const token = useSelector((state) => state?.Auth?.token);
	const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
	const [userPrescrip, setUserPrescrip] = useState("");

	// Get Prescription
	useEffect(() => {
		getPatientviewperscriptionapi(
			orderdetail?.booking_detail?.booking_id,
			token,
		).then((res) => {
			dispatch(P_DETAIL(res?.data));
			console.log(res?.data, "user prescription");
			setUserPrescrip(res?.data);
		});
	}, []);
	//   ==================

	let specialties = [];
	try {
		const specialization = userPrescrip?.physician_detail?.specialization;
		specialties = specialization ? JSON.parse(specialization) : [];
	} catch (error) {}

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div className="edit-btn back">
										<Link
											to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}
										>
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 className="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											User Prescription
										</h5>
										{/* <UserConsultationTab /> */}
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={
														orderdetail?.physician_detail?.profile_image_url
															? orderdetail?.physician_detail?.profile_image_url
															: consultantmage
													}
													className="img-fluid profie_img"
													alt=""
												/>
												<div>
													<h4 className="main-heading-font level-6 ">
														{userPrescrip?.physician_detail?.title}
													</h4>
													<div className="prescription_dv_show d-flex ">
														{specialties.map((specialty, index) => (
															<h5 className="primary-medium-font level-8 extra-color-10 me-2">
																{specialty}
															</h5>
														))}
													</div>
													<h4 className="primary-medium-font level-7 ">
														<span className="icon-point">
															<i className="fa-solid fa-location-dot"></i>
														</span>{" "}
														{userPrescrip?.physician_detail?.address}
													</h4>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<h4 className="main-heading-font level-6 ">
												Prescription
											</h4>
											<div className="row mb-4">
												{userPrescrip?.prescription?.prescriptions?.map(
													(item, uindex) => {
														return (
															<>
																<div
																	className="col-lg-3 col-md-6 mb-2"
																	key={uindex}
																>
																	<div className="content-qty extra-bg-17 radius-20 p-3 dark-color ">
																		<h4 className="primary-medium-font level-7 ">
																			{item?.prescription}
																		</h4>
																		<h5 className="primary-medium-font level-8 extra-color-15">
																			{item?.quantity}
																		</h5>
																	</div>
																</div>
															</>
														);
													},
												)}
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-2">
									<div className="col-lg-12">
										<div className="d-flex align-items-center gap-3">
											{orderdetail?.booking_detail?.appointment_status !=
											"Upcoming" ? (
												<>
													<Link
														className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
														to="/user-prescription-placeorder"
													>
														<span className="bg-wrapper w-100">Buy Now </span>
													</Link>

													<Link className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none">
														<span className="bg-wrapper w-100">
															I’ll Buy on my own
														</span>
													</Link>
												</>
											) : null}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserPrescription;
